import { deviceIdGet, sessionIdGet, windowIdGet } from '@codestreet/utils'
import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

import { env } from '@/shared/config'

export function sentryPlugin(app: App, router: Router) {
  const isProd = env.MODE === 'production'
  const sampleRate = isProd ? 0.01 : 1

  // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/
  Sentry.init({
    app,
    enabled: isProd,
    dsn: env.SENTRY_DNS,
    debug: false,
    release: env.PROJECT_NAME + '@' + env.VERSION,
    environment: env.MODE,
    sampleRate,
    maxBreadcrumbs: 300,
    attachStacktrace: true,
    transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
    integrations: [
      Sentry.browserTracingIntegration({
        router,
      }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    tracePropagationTargets: ['localhost', env.HOST_NAME],
    tracesSampleRate: sampleRate,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb.category === 'ui.click' ? null : breadcrumb
    },
  })

  Sentry.setContext('app', {
    deviceId: deviceIdGet(),
    windowId: windowIdGet(),
    sessionId: sessionIdGet(),
  })
}
